import React from 'react';
import { Route } from 'react-router-dom';

import { TrackedRoutes } from '../../components/TrackedRoutes';

import { ChatList, CreateChat, EditChat } from './components';

export const ChatsPage: React.FC = () => {
  return (
    <TrackedRoutes>
      <Route index element={<ChatList />} />
      <Route path="create" element={<CreateChat />} />
      <Route path=":chatId" element={<EditChat />} />
    </TrackedRoutes>
  );
};
